import { Show, type JSX } from 'solid-js';
import { Glyph, type GlyphName } from '~/components/glyph';
import type { Tone } from '~/types/game';

interface DockButtonProps {
  icon: GlyphName;
  label: string;
  active?: boolean;
  tone?: Tone;
  notify?: boolean;
  onClick?: () => void;
}

export function DockButton(props: DockButtonProps) {
  const style = (): JSX.CSSProperties => ({
    flex: 1,
    background: props.active ? 'var(--sf-elev)' : 'transparent',
    border: '1px solid ' + (props.active ? 'var(--line-strong)' : 'transparent'),
    'border-radius': 'var(--r-1)',
    color: props.active ? (props.tone ? `var(--${props.tone})` : 'var(--fg)') : 'var(--fg-mute)',
    padding: '8px 4px 6px',
    display: 'flex',
    'flex-direction': 'column',
    'align-items': 'center',
    gap: '4px',
    cursor: 'pointer',
    'font-family': 'var(--mono)',
    transition: 'all var(--dur) var(--ease)',
    position: 'relative',
  });
  return (
    <button onClick={() => props.onClick?.()} style={style()}>
      <Glyph name={props.icon} size={18} />
      <span style={{ 'font-size': '9px', 'letter-spacing': '0.14em', 'text-transform': 'uppercase' }}>
        {props.label}
      </span>
      <Show when={props.notify}>
        <span
          style={{
            position: 'absolute',
            top: '6px',
            right: '14px',
            width: '6px',
            height: '6px',
            'border-radius': 0,
            background: 'var(--hostile)',
          }}
        />
      </Show>
    </button>
  );
}
